import { Users } from 'react-feather'

export default [
  {
    id: 'passengerBusManagement',
    title: 'Passenger Bus Management',
    icon: <Users size={20} />,
    // No action/resource on the module wrapper itself — visibility is derived
    // from accessible descendants so the module appears when the user has
    // ANY passenger-bus permission (not just PBPassengerBus).
    children: [
      {
        id: 'broadcastOperators',
        title: 'Broadcast to Operators',
        navLink: '/passenger-bus/broadcast'
      },
      {
        id: 'operatorList',
        title: 'Operators',
        navLink: '/passenger-bus/operators',
        action: 'read',
        resource: 'PBOperator'
      },
      {
        id: 'routeApplicationList',
        title: 'Route Applications',
        children: [
          {
            id: 'newApplications',
            title: 'New Applications',
            navLink: '/passenger-bus/route-applications',
            action: 'read',
            resource: 'PBRouteApplication'
          },
          {
            id: 'pastApplications',
            title: 'Past Applications',
            navLink: '/passenger-bus/route-applications/past',
            action: 'read',
            resource: 'PBRouteApplication'
          }
        ]
      },
      {
        id: 'busInspectionList',
        title: 'Bus Inspections',
        children: [
          {
            id: 'busInspectionApplications',
            title: 'New Applications',
            navLink: '/passenger-bus/bus-inspections/applications',
            action: 'read',
            resource: 'PBBusInspectionApplication'
          },
          {
            id: 'busInspectionRecords',
            title: 'Past Applications',
            navLink: '/passenger-bus/bus-inspections/list',
            action: 'read',
            resource: 'PBBusInspection'
          }
        ]
      },
      {
        id: 'routePermitList',
        title: 'Route Permits',
        navLink: '/passenger-bus/route-permits',
        action: 'read',
        resource: 'PBRoutePermit'
      },
      {
        id: 'routeSuspensionList',
        title: 'Route Suspensions',
        navLink: '/passenger-bus/route-suspensions',
        action: 'read',
        resource: 'PBRouteSuspension'
      },
      {
        id: 'routeCancellationList',
        title: 'Route Cancellations',
        navLink: '/passenger-bus/route-cancellations',
        action: 'read',
        resource: 'PBRouteCancellation'
      },
      {
        id: 'busFleet',
        title: 'Bus Fleet',
        navLink: '/passenger-bus/fleet',
        action: 'read',
        resource: 'PBFleet'
      },
      {
        id: 'passengerBusList',
        title: 'Buses',
        navLink: '/passenger-bus/buses',
        action: 'read',
        resource: 'PBPassengerBus'
      },
      {
        id: 'driverList',
        title: 'Drivers',
        navLink: '/passenger-bus/drivers',
        action: 'read',
        resource: 'PBDriver'
      },
      {
        id: 'conductorList',
        title: 'Conductors',
        navLink: '/passenger-bus/conductors',
        action: 'read',
        resource: 'PBConductor'
      },
      {
        id: 'certificationList',
        title: 'Certifications',
        children: [
          {
            id: 'driverCertificationList',
            title: 'Driver Certifications',
            navLink: '/passenger-bus/certifications/driver-certifications',
            action: 'read',
            resource: 'PBDriverCertification'
          },
          {
            id: 'conductorCertificationList',
            title: 'Conductor Certifications',
            navLink: '/passenger-bus/certifications/conductor-certifications',
            action: 'read',
            resource: 'PBConductorCertification'
          }
        ]
      },
      {
        id: 'legacyRoutes',
        title: 'Legacy Routes',
        navLink: '/passenger-bus/legacy-routes',
        action: 'read',
        resource: 'PBLegacyRoute'
      },
      {
        id: 'passengerBusMasters',
        title: 'Masters',
        children: [
          // Routes and Schedules
          {
            id: 'routeList',
            title: 'Routes',
            navLink: '/passenger-bus/routes',
            action: 'read',
            resource: 'PBRoute'
          },
          {
            id: 'routeScheduleList',
            title: 'Route Schedules',
            navLink: '/passenger-bus/route-schedules',
            action: 'read',
            resource: 'PBRouteSchedule'
          },
          // Common Masters (Passenger Bus API)
          {
            id: 'dzongkhagList',
            title: 'Dzongkhags',
            navLink: '/passenger-bus/dzongkhags',
            action: 'read',
            resource: 'PBDzongkhag'
          },
          {
            id: 'gewogList',
            title: 'Gewogs',
            navLink: '/passenger-bus/gewogs',
            action: 'read',
            resource: 'PBGewog'
          },
          // Passenger Bus Masters
          {
            id: 'busTypeList',
            title: 'Bus Types',
            navLink: '/passenger-bus/bus-types',
            action: 'read',
            resource: 'PBBusType'
          },
          {
            id: 'placeList',
            title: 'Places',
            navLink: '/passenger-bus/places',
            action: 'read',
            resource: 'PBPlace'
          },
          {
            id: 'roadTypeList',
            title: 'Road Types',
            navLink: '/passenger-bus/road-types',
            action: 'read',
            resource: 'PBRoadType'
          },
          {
            id: 'roadConditionList',
            title: 'Road Conditions',
            navLink: '/passenger-bus/road-conditions',
            action: 'read',
            resource: 'PBRoadCondition'
          },
          {
            id: 'driveTypeList',
            title: 'Drive Types',
            navLink: '/passenger-bus/drive-types',
            action: 'read',
            resource: 'PBDriveType'
          }
        ]
      }
    ]
  }
]
